module.exports = "<div class=\"modal-header\">\n  <h2>{{'menu.catalog.title' | translate}}</h2>\n  <div class=\"action-buttons\">\n    <button ng-click=\"cancel()\" ng-disabled=\"loading.menu\" class=\"button secondary\">{{'common.buttons.cancel' | translate}}</button>\n    <button ng-click=\"save()\" ng-disabled=\"loading.menu\" class=\"button\">{{'common.buttons.join' | translate}}</button>\n  </div>\n</div>\n\n<menu-catalog ng-if=\"!loading.menu\" select selected-products=\"products\" choose-products=\"true\"></menu-catalog>\n\n<div class=\"loader\" ng-if=\"loading.menu\"></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/main/item/item.select.modal.html
 ** module id = 607
 ** module chunks = 0
 **/